/* Keep the shared welcome form and teaser aligned with the active Shopify offer. */
(() => {
  const selector = '[data-testid="klaviyo-form-RUYKP7"], .klaviyo-form-RUYKP7, .kl-teaser-RUYKP7';
  const code = 'WELCOME20';
  const updateCopy = (text) => text.replace(/WELCOME50/gi, code).replace(/\b50\s*%/g, '20%')
    .replace(/Join the Blade\s?Orbit list/gi, 'Join our mailing list')
    .replace(/Blade\s?Orbit[™®]?\s*/gi, '');

  function updateOffer(root) {
    const walker = document.createTreeWalker(root, NodeFilter.SHOW_TEXT);
    let node;
    while ((node = walker.nextNode())) {
      if (node.parentElement?.closest('script, style, textarea')) continue;
      const updated = updateCopy(node.nodeValue);
      if (updated !== node.nodeValue) node.nodeValue = updated;
    }
    [root, ...root.querySelectorAll('[href], [aria-label], [title], input')].forEach((element) => {
      const href = element.getAttribute('href');
      if (href && /WELCOME50/i.test(href)) element.setAttribute('href', href.replace(/WELCOME50/gi, code));
      for (const attribute of ['aria-label', 'title']) {
        const value = element.getAttribute(attribute);
        if (value && updateCopy(value) !== value) element.setAttribute(attribute, updateCopy(value));
      }
      if (element instanceof HTMLInputElement && /^WELCOME50$/i.test(element.value)) {
        element.value = code;
      }
    });
  }

  function synchronize() {
    document.querySelectorAll(selector).forEach(updateOffer);
  }
  // Run before the asynchronous form loads, including any subsequent form steps.
  new MutationObserver(synchronize).observe(document.documentElement, {
    subtree: true,
    childList: true,
    characterData: true,
    attributes: true,
    attributeFilter: ['href', 'aria-label', 'title', 'value'],
  });
  synchronize();

  // If the hosted form offers a copy-code action, copy the displayed, active code.
  document.addEventListener('click', (event) => {
    if (!(event.target instanceof Element)) return;
    const button = event.target.closest('button, [role="button"]');
    if (!button?.closest(selector)) return;
    const label = `${button.textContent} ${button.getAttribute('aria-label') || ''}`;
    if (!/\bcopy(?:\s+(?:discount\s+)?code)?\b/i.test(label)) return;
    event.preventDefault();
    event.stopImmediatePropagation();
    const original = button.textContent;
    navigator.clipboard.writeText(code).then(() => {
      button.textContent = 'Copied!';
      setTimeout(() => { if (button.isConnected) button.textContent = original; }, 2000);
    }).catch(() => {
      button.textContent = code;
    });
  }, true);
})();
